import { usePromiseTracker } from "react-promise-tracker";
import "./LoadingIndicator.css";

const LoadingIndicator = (props) => {
  const { promiseInProgress } = usePromiseTracker();
  const visible = promiseInProgress || props.showLoading;

  if (!visible) return null;

  return (
    <div className="ef-loading-overlay">
      <div className="ef-loading__spinner" />
    </div>
  );
};

export default LoadingIndicator;
